import { RootState } from '@redux/store'

export const mainScreenSelectedTabSelector = ({ main }: RootState) =>
  main.selectedTab
